<div class="maintenance-page">
  <div class="content-box">
    <h1>{{ status?.title || 'Onderhoud' }}</h1>
    <p class="text">{{ status?.message || 'De werkplaats is tijdelijk niet beschikbaar vanwege onderhoud. Probeer het later opnieuw.' }}</p>
  </div>
</div>
